// navbar

let navDropDownItem = document.querySelectorAll(".nav_dropdown-wrap");

navDropDownItem.forEach((el) => {
  let navDropDownLink = el.querySelector(".nav_dropdown-link");
  let navDropDownContent = el.querySelector(".nav_dropdown-content");
  let navDropDownIcon = el.querySelector(".dropdown-icon");

  let navDropDown = gsap.timeline({ paused: true });

  navDropDown
    .set(navDropDownContent, {
      display: "flex",
    })
    .from(navDropDownContent, {
      opacity: 0,
      duration: 0.25,
      ease: "power4.inout",
    })
    .to(
      navDropDownIcon,
      {
        rotate: 180,
        duration: 0.25,
        ease: "power4.inout",
      },
      "<"
    );

  function setupDropDownBehavior() {
    if (window.innerWidth > 911) {
      // Set up hover event listeners for larger screen sizes
      navDropDownLink.addEventListener("mouseover", () => {
        navDropDown.play();
      });

      navDropDownLink.addEventListener("mouseleave", () => {
        if (!navDropDownContent.matches(":hover")) {
          navDropDown.reverse();
        }
      });

      navDropDownContent.addEventListener("mouseleave", () => {
        navDropDown.reverse();
      });
    } else {
      // Set up click event listener for smaller screen sizes
      navDropDownLink.addEventListener("click", () => {
        if (navDropDown.progress() === 0) {
          navDropDown.play();
        } else {
          navDropDown.reverse();
        }
      });
    }
  }

  // Call the function initially
  setupDropDownBehavior();

  // Listen for resize events and update behavior
  window.addEventListener("resize", setupDropDownBehavior);
});

// mobile menu

let mm = gsap.matchMedia();

mm.add("(max-width: 911px)", () => {
  let hamburgerButton = document.querySelector(".nav_hamburger");
  let mobileMenuWrap = document.querySelector(".nav_left");
  let mobileMenuLinks = mobileMenuWrap.querySelectorAll(
    ":scope .nav_dropdown-link, :scope .nav_link"
  );

  let mobileMenuOpen = gsap.timeline({ paused: true });

  mobileMenuOpen
    .set(mobileMenuWrap, {
      display: "flex",
    })
    .from(mobileMenuWrap, {
      y: "-100%",
      duration: 0.75,
      ease: "power2.inOut",
    })
    .from(
      mobileMenuLinks,
      {
        opacity: 0,
        x: "1rem",
        duration: 0.35,
        stagger: { amount: 0.25 },
      },
      "<0.5"
    );

  let menuOpenState = false;

  hamburgerButton.addEventListener("click", () => {
    if (menuOpenState === false) {
      mobileMenuOpen.play();
      menuOpenState = true;
    } else {
      mobileMenuOpen.reverse();
      menuOpenState = false;
    }
  });
});

/* let navbar = document.querySelector(".nav_comp");

let navbarMove = gsap.timeline({
  scrollTrigger: {
    trigger: ".section_header",
    scrub: 1,
    start: "top top", // Animation starts at the top of the page
    end: "top+=80", // Animation ends when scrolled 64px down
    markers: false,
  },
});

navbarMove.to(navbar, { y: "0%" }); */
